import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsByAgentIdOptions } from '@onefootprint/fetch-dashboard';
import { useQueries } from '@tanstack/react-query';

// Batch-resolve agent names by id for frames that arrive without one (route-derived contexts lag store
// hydration; some Percy emissions omit it). Returns a map of id → name for those that resolved; callers
// fall back to the id otherwise.
export const useAgentNames = agentIds => {
  const $ = _c(7);
  let t0;
  if ($[0] !== agentIds) {
    t0 = agentIds.map(_temp);
    $[0] = agentIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      queries: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const results = useQueries(t1);
  let names;
  if ($[4] !== agentIds || $[5] !== results) {
    names = new Map();
    agentIds.forEach((agentId_0, i) => {
      const name = results[i]?.data?.name;
      if (name) {
        names.set(agentId_0, name);
      }
    });
    $[4] = agentIds;
    $[5] = results;
    $[6] = names;
  } else {
    names = $[6];
  }
  return names;
};
function _temp(agentId) {
  return {
    ...getOrgAgentsByAgentIdOptions({
      path: {
        agentId
      }
    }),
    enabled: !!agentId
  };
}